/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ side',
  jump_to: 'GÃ¥ til',
  jump_to_confirm: 'bekrÃ¦ft',
  page: '',

  // Pagination.jsx
  prev_page: 'Forrige Side',
  next_page: 'NÃ¦ste Side',
  prev_5: 'Forrige 5 Sider',
  next_5: 'NÃ¦ste 5 Sider',
  prev_3: 'Forrige 3 Sider',
  next_3: 'NÃ¦ste 3 Sider'
};
